import(/* webpackMode: "eager" */ "/vercel/path0/src/containers/dao/DeWiHallEntry.tsx")